const AssessmentAccessLevels = {
  private: "private",
  enterprise: "enterprise",
  public: "public",
}

module.exports = AssessmentAccessLevels
